import { gql } from "@apollo/client";

export const DEACTIVATE_USER = gql`
  mutation DeactivateUser($id: Int!) {
    deactivateAccount(id: $id) {
      id
      firstName
      lastName
      summary
      timeZone
      createdOn
      updatedOn
    }
  }
`;

export const REACTIVATE_USER = gql`
  mutation ReactivateUser($id: Int!) {
    reactivateAccount(id: $id) {
      id
      firstName
      lastName
      summary
      timeZone
      createdOn
      updatedOn
    }
  }
`;
